import {
  COMMON_ACTION,
  GET_BLOGS_ACTION,
  GET_LATEST_NEWS_ACTION,
  ISSUE_ACTION,
  STATUS
} from "../constant";

const initState = {
  issuesList: [],
  toggleSideBar: false,
  isImageUpLoading: false,
  issuesCategoryList: [],
  isApiLoading: "",
  issueListStatus: "",
  searchInput: "",
  permissionsListing: [],
  projectListDownLoadUrl: null,
  isProjectListDownLoading: null,
  isPermissionsLoading: STATUS.LOADING,
  uploadStatus: 0
};

export default function common(state = initState, action) {
  switch (action.type) {
    case COMMON_ACTION.TOGGLE_SIDEBAR: {
      return { ...state, toggleSideBar: !state.toggleSideBar };
    }

    case COMMON_ACTION.IMAGE_UPLOADING_START:
      return { ...state, isImageUpLoading: STATUS.LOADING };

    case COMMON_ACTION.IMAGE_UPLOADING_FAILURE:
      return { ...state, isImageUpLoading: STATUS.ERROR };

    case COMMON_ACTION.IMAGE_UPLOADING_SUCCESS:
      return { ...state, isImageUpLoading: STATUS.SUCCESS };

    case COMMON_ACTION.ISSUE_LIST_START:
      return { ...state, issueListStatus: STATUS.LOADING };

    case COMMON_ACTION.ISSUE_LIST_SUCCESS: {
      return {
        ...state,
        issueList: action.payload,
        issueListStatus: STATUS.SUCCESS
      };
    }
    case COMMON_ACTION.ISSUE_LIST_FAILURE:
      return { ...state, issueListStatus: STATUS.ERROR };

    case COMMON_ACTION.SEARCH_INPUT_DATA:
      return { ...state, searchInput: action.payload };
    case COMMON_ACTION.RESET_SEARCH_INPUT_DATA:
      return { ...state, searchInput: "" };
    case COMMON_ACTION.PROJECT_LIST_FAILURE:
      return { ...state, isApiLoading: STATUS.ERROR };
    case COMMON_ACTION.PROJECT_LIST_START:
      return { ...state, status: STATUS.LOADING };
    case COMMON_ACTION.PROJECT_LIST_SUCCESS: {
      return {
        ...state,
        projectList: action.payload,
        status: STATUS.SUCCESS
      };
    }

    case COMMON_ACTION.GET_ISSUES_CATEGORY_LIST_START:
      return { ...state, issuesCategoryListStatus: STATUS.LOADING };
    case COMMON_ACTION.GET_ISSUES_CATEGORY_LIST_SUCCESS:
      return {
        ...state,
        issuesCategoryList: action.payload,
        issuesCategoryListStatus: STATUS.SUCCESS
      };
    case COMMON_ACTION.GET_ISSUES_CATEGORY_LIST_FAILURE:
      return { ...state, issuesCategoryListStatus: STATUS.ERROR };

    case COMMON_ACTION.GET_FORUM_LIST_START:
      return { ...state, forumListStatus: STATUS.LOADING };
    case COMMON_ACTION.GET_FORUM_LIST_SUCCESS:
      return {
        ...state,
        forumList: action.payload,
        forumListStatus: STATUS.SUCCESS
      };
    case COMMON_ACTION.GET_FORUM_LIST_FAILURE:
      return { ...state, forumListStatus: STATUS.ERROR };

    case COMMON_ACTION.GET_BUCKET_LIST_START:
      return { ...state, BucketListStatus: STATUS.LOADING };
    case COMMON_ACTION.GET_BUCKET_LIST_SUCCESS:
      return {
        ...state,
        bucketList: action.payload,
        BucketListStatus: STATUS.SUCCESS
      };
    case COMMON_ACTION.GET_BUCKET_LIST_FAILURE:
      return { ...state, BucketListStatus: STATUS.ERROR };

    case COMMON_ACTION.GET_MILESTONE_TABLE_START:
      return { ...state, milestoneTableStatus: STATUS.LOADING };
    case COMMON_ACTION.GET_MILESTONE_TABLE_SUCCESS:
      return {
        ...state,
        milesTableList: action.payload,
        milestoneTableStatus: STATUS.SUCCESS
      };
    case COMMON_ACTION.GET_MILESTONE_TABLE_FAILURE:
      return { ...state, milestoneTableStatus: STATUS.ERROR };

    case COMMON_ACTION.GET_MILESTONE_LIST_START:
      return { ...state, milestoneDataListStatus: STATUS.LOADING };
    case COMMON_ACTION.GET_MILESTONE_LIST_SUCCESS:
      return {
        ...state,
        milestoneDataList: action.payload,
        milestoneDataListStatus: STATUS.SUCCESS
      };
    case COMMON_ACTION.GET_MILESTONE_LIST_FAILURE:
      return { ...state, milestoneDataListStatus: STATUS.ERROR };

    case COMMON_ACTION.GET_ISSUES_SUB_CATEGORY_LIST_START:
      return { ...state, issuesSubCategoryListStatus: STATUS.LOADING };
    case COMMON_ACTION.GET_ISSUES_SUB_CATEGORY_LIST_SUCCESS:
      return { ...state, issuesSubCategoryListStatus: STATUS.LOADING };
    case COMMON_ACTION.GET_ISSUES_SUB_CATEGORY_LIST_FAILURE:
      return { ...state, issuesSubCategoryListStatus: STATUS.LOADING };

    case COMMON_ACTION.DELETE_IMAGE_UPLOADING_START:
      return { ...state, isApiLoading: STATUS.LOADING };

    case COMMON_ACTION.GET_GROUP_BY_ID_FAILURE:
    case COMMON_ACTION.DELETE_IMAGE_UPLOADING_FAILURE:
      return { ...state, isApiLoading: STATUS.ERROR };

    case COMMON_ACTION.GET_GROUP_BY_ID_SUCCESS:
    case COMMON_ACTION.DELETE_IMAGE_UPLOADING_SUCCESS:
      console.log("from common reducer");
      return { ...state, isApiLoading: STATUS.SUCCESS };

    case COMMON_ACTION.GET_PERMISSIONS_LIST_START:
      return {
        ...state,
        isApiLoading: STATUS.LOADING,
        isPermissionsLoading: STATUS.LOADING
      };
    case COMMON_ACTION.GET_PERMISSIONS_LIST_FAILURE:
      return {
        ...state,
        isApiLoading: STATUS.ERROR,
        isPermissionsLoading: STATUS.LOADING
      };
    case COMMON_ACTION.GET_PERMISSIONS_LIST_SUCCESS:
      return {
        ...state,
        isApiLoading: STATUS.SUCCESS,
        permissionsListing: action.payload,
        isPermissionsLoading: STATUS.LOADING
      };

    case COMMON_ACTION.CLEAR_PERMISSION:
      return {
        ...state,
        permissionListing: null
      };

    case COMMON_ACTION.CLEAR_ISSUE_DETAILS:
      return {
        ...state,
        issueList: null,
        issueListStatus: null
      };

    case COMMON_ACTION.PROJECT_LIST_REPORT_DOWNLOAD_START:
      return {
        ...state,
        projectListDownLoadUrl: null,
        isProjectListDownLoading: STATUS.LOADING
      };

    case COMMON_ACTION.PROJECT_LIST_REPORT_DOWNLOAD_SUCCESS:
      return {
        ...state,
        projectListDownLoadUrl: action.payload,
        isProjectListDownLoading: action.payload
          ? STATUS.SUCCESS
          : STATUS.LOADING
      };

    case COMMON_ACTION.PROJECT_LIST_REPORT_DOWNLOAD_FAILURE:
      return {
        ...state,
        projectListDownLoadUrl: null,
        isProjectListDownLoading: STATUS.ERROR
      };

    case COMMON_ACTION.CLEAR_PROJECT_LIST_REPORT_DOWNLOAD:
      return {
        ...state,
        projectListDownLoadUrl: null,
        isProjectListDownLoading: null
      };

    case COMMON_ACTION.UPLOADING_START:
      return { ...state, uploadStatus: 0 };

    case COMMON_ACTION.UPLOADING_SUCCESS:
      return { ...state, uploadStatus: action.payload };

    case COMMON_ACTION.UPLOADING_FAILURE:
      return { ...state, uploadStatus: 0 };

    case GET_LATEST_NEWS_ACTION.GET_LATEST_NEWS_START:
      return { ...state, newsStatusLoader: true };

    case GET_LATEST_NEWS_ACTION.GET_LATEST_NEWS_SUCCESS:
      return {
        ...state,
        newsStatusLoader: false,
        latestNews: action.payload
      };

    case GET_LATEST_NEWS_ACTION.GET_LATEST_NEWS_FAILURE:
      return { ...state, newsStatusLoader: false };

    case GET_BLOGS_ACTION.GET_BLOGS_START:
      return { ...state, blogsStatusLoader: true };

    case GET_BLOGS_ACTION.GET_BLOGS_SUCCESS:
      return {
        ...state,
        blogsStatusLoader: false,
        blogs: action.payload
      };

    case GET_BLOGS_ACTION.GET_BLOGS_FAILURE:
      return { ...state, blogsStatusLoader: false };

    case COMMON_ACTION.WINDOW_RESIZE: {
      return { ...state, isDesktopView: action.data };
    }

    default:
      return state;
  }
}
